import r from"styled-components";import{theme as i}from"../../../../../theme.js";const a=r.div`
  padding: 0 ${i.spacing*4}px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-column-gap: ${i.spacing*4}px;
  grid-row-gap: ${i.spacing*2}px;
  @media screen and (max-width: ${i.breakpoints.md}) {
    grid-template-columns: 1fr;
    padding: ${i.spacing*4}px;
  }
`,e=r.div`
  display: flex;
  align-items: center;
  gap: ${i.spacing*2}px;
  padding: ${i.spacing*2}px;
  background-color: ${({active:p})=>p?i.colors.success[50]:i.colors.gray[100]};
  border-radius: ${i.radius}px;
  cursor: pointer;
  .label {
    font-size: 14px;
    line-height: 24px;
    color: ${i.colors.gray[800]};
  }
  > svg {
    width: 24px;
    height: 24px;
  }
`;export{a as Container,e as FeelingContainer};
